import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@platzi/ui';
import { getFollowSchools, followSchool, unFollowSchool } from 'src/api';
import { FollowModal } from './FollowModal';
import styles from './FollowSchool.module.sass';

export const FollowSchool = () => {
  const { t } = useTranslation();
  const schoolId = useSelector((state) => state.get('school').get('id')) || 1;
  const [userFollowSchool, setUserFollowSchool] = useState(undefined);
  const [userSchoolId, setUserSchoolId] = useState(0);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    getFollowSchools()
      .then((res) => {
        const isFollowing = res.data?.filter((item) => item.learningPathId === schoolId);

        if (isFollowing.length > 0) {
          setUserSchoolId(isFollowing[0].id);
          setUserFollowSchool(true);
        } else {
          setUserFollowSchool(false);
        }
      })
      .catch((err) => {
        throw new Error('::ERROR::GET_FOLLOW_SCHOOLS', { cause: err });
      });
  }, []);

  const toggleFollow = () => {
    if (!userFollowSchool) {
      const payload = {
        level: 'basic',
      };

      followSchool(schoolId, payload)
        .then((res) => {
          setUserFollowSchool(true);
          setUserSchoolId(res?.data?.id);
        })
        .catch((err) => {
          throw new Error('::ERROR::FOLLOW_SCHOOL', { cause: err });
        });
    } else {
      setShowConfirmationModal(true);
    }
  };

  const handleUnfollow = () => {
    setShowConfirmationModal(false);
    unFollowSchool(userSchoolId)
      .then(() => setUserFollowSchool(false))
      .catch((err) => {
        throw new Error('::ERROR::UNFOLLOW_SCHOOL', { cause: err });
      });
  };

  const renderButtonContent = () => {
    if (!userFollowSchool) {
      return t('escuela.followSchool.follow');
    } else {
      return (
        <>
          <FontAwesomeIcon icon={faCircleCheck} />
          {t('escuela.followSchool.unfollow')}
        </>
      );
    }
  };

  const buttonState = classnames(styles.Button, { [styles.Unfollow]: userFollowSchool });

  return (
    <>
      {userFollowSchool !== undefined && (
        <div className={styles.Container}>
          <Button as="button" onClick={toggleFollow} customClass={buttonState}>
            {renderButtonContent()}
          </Button>
          {userFollowSchool && <span>{t('escuela.followSchool.help')}</span>}
        </div>
      )}
      <FollowModal showModal={showConfirmationModal} closeModal={setShowConfirmationModal} unfollow={handleUnfollow} />
    </>
  );
};
